import  { useState, useEffect } from "react";
import "../styles/Gallery.css";

const Gallery = () => {
  const [albums, setAlbums] = useState([]);
  const [photos, setPhotos] = useState([]);
  const [selectedAlbum, setSelectedAlbum] = useState(null);
  const [selectedImage, setSelectedImage] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Fetch albums from backend
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });

    const fetchAlbums = async () => {
      setLoading(true);
      try {
        const response = await fetch(
          `${process.env.REACT_APP_URL_SCHEME}${process.env.REACT_APP_IP_ADDRESS}/api/albums`
        );
        if (!response.ok) throw new Error("Failed to fetch albums");

        const data = await response.json();
        setAlbums(data);

        if (data.length > 0) {
          setSelectedAlbum(data[0].folderId);
          fetchPhotos(data[0].folderId);
        }
      } catch (error) {
        console.error("Error fetching albums:", error.message);
        setError("Error fetching albums");
      } finally {
        setLoading(false);
      }
    };

    fetchAlbums();
  }, []);

  // Fetch photos from selected album
  const fetchPhotos = async (folderId) => {
    setSelectedAlbum(folderId);
    setLoading(true);
    setError(null);

    try {
      const response = await fetch(
        `${process.env.REACT_APP_URL_SCHEME}${process.env.REACT_APP_IP_ADDRESS}/api/photos/${folderId}`
      );
      if (!response.ok) throw new Error("Failed to fetch photos");

      const data = await response.json();
      setPhotos(data);
    } catch (error) {
      console.error("Error fetching photos:", error.message);
      setError("Error fetching photos");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <div className="gallery-container">
        <h1>Gallery</h1>

        {/* Album Buttons */}
        <div className="album-buttons">
          {error ? (
            <p>{error}</p>
          ) : albums.length > 0 ? (
            albums.map((album) => (
              <button
                key={album.folderId}
                className="album-button"
                onClick={() => fetchPhotos(album.folderId)}
                style={{
                  border:
                    selectedAlbum === album.folderId
                      ? "0.5px solid white"
                      : "none",
                  transition: "border 1s ease-in-out",
                }}
              >
                {album.name}
              </button>
            ))
          ) : !loading ? (
            <p className="loading-text">No albums available.</p>
          ) : (
            <p className="loading-text">Looking for albums...</p>
          )}
        </div>

        {/* Photos Display */}
        {loading && !error ? (
          <div className="loading-container">
            <p className="loading-text">Loading...</p>
            <div className="spinner"></div>
          </div>
        ) : photos.length > 0 && !error ? (
          <div className="gallery-grid">
            {photos.map((photo, index) => (
              <div className="gallery-card" key={index}>
                <img
                  src={photo.url}
                  alt={photo.name}
                  onClick={() => setSelectedImage(photo.url)}
                  loading="lazy"
                  style={{
                    opacity: loading ? 0.5 : 1,
                    filter: loading ? "blur(10px)" : "none",
                    transition: "opacity 1s ease-in-out",
                  }}
                />
              </div>
            ))}
          </div>
        ) : (
          <p className="loading-text">No photos found in this album.</p>
        )}
      </div>

      {/* Image Modal */}
      {selectedImage && (
        <div className="image-modal">
          <div className="selected-image">
            <button className="close-bttn" onClick={() => setSelectedImage(null)}>
              &times;
            </button>
            <img src={selectedImage} alt="Enlarged" />
          </div>
        </div>
      )}
    </div>
  );
};

export default Gallery;
